import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { Checkbox } from "@folio/stripes/components";
export var useInternationalPrefixTable = function (onRowClick, onDefaultAgencyChange) {
    var formatMessage = useIntl().formatMessage;
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.internationalPrefixes.table.columns.agency",
            }),
            key: "agency",
            clickable: true,
            onClick: onRowClick,
        },
        {
            name: formatMessage({
                id: "ui-br-agency.internationalPrefixes.table.columns.defaultAgency",
            }),
            key: "defaultAgency",
            cellRenderer: function (item) {
                return React.createElement(Checkbox, {
                    checked: item.defaultAgency,
                    disabled: true,
                    onChange: function () { return onDefaultAgencyChange === null || onDefaultAgencyChange === void 0 ? void 0 : onDefaultAgencyChange(item); },
                });
            },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.internationalPrefixes.table.columns.value",
            }),
            key: "value",
            cellRenderer: function (item) { var _a; return (_a = item.value) !== null && _a !== void 0 ? _a : "N/A"; },
        },
    ]; }, [formatMessage, onRowClick, onDefaultAgencyChange]);
    return { columns: columns };
};
